import React, { FC } from 'react';
import { TabButton, TabsCont } from './TabGroup.styles';
import { CreateSurveyCardsNames, CreateSurveyTypeNames } from '../../constans/state';

interface ITabGroup {
  tabs: { name: string; value: string }[];
  applyFilters: (filters: any) => void;
  defaultValue?: string;
  surveyOverviewType: string;
  selectedTab: string;
  setBlockedTab: (tab: any) => void;
  isTransitionBlocked: boolean;
}

const TabGroup: FC<ITabGroup> = ({
  tabs,
  selectedTab,
  applyFilters,
  setBlockedTab,
  surveyOverviewType,
  isTransitionBlocked,
}) => {
  const changeCard = (card: string) => {
    if (isTransitionBlocked) {
      setBlockedTab(card);
    }

    const domain =
      card === CreateSurveyCardsNames.participantsandreports
        ? CreateSurveyTypeNames.reportsSetup
        : surveyOverviewType === 'EFFECT' && card === CreateSurveyCardsNames.contents
          ? CreateSurveyTypeNames.internal
          : null;

    const clearedFilters = {
      pageNo: null,
      sortOrder: null,
      perPage: null,
      addTeam: null,
      compare: null,
      compareSort: null,
      activeSection: null,
      surveyReport: null,
      prm: null,
      riskAnalysis: null,
      predictiveStates: null,
      search: null,
      language: null,
      reports: null,
      domain,
      card,
    };
    applyFilters(clearedFilters);
  };

  return (
    <TabsCont id="TabsCont" data-testid="tabsContainer">
      {tabs.map((tab, index) => (
        <TabButton
          id="TabButton"
          key={index}
          data-testid="tab"
          isSelected={selectedTab === tab.value}
          onClick={() => changeCard(tab.value)}
        >
          {tab.name}
        </TabButton>
      ))}
    </TabsCont>
  );
};

export default TabGroup;
